import { chunk } from "./array";

const PAGE_SIZE = 7;
export const questionnairePageCount = (questions) =>
  Math.ceil(questions.length / PAGE_SIZE);
export const questionnairePages = (questions) => chunk(questions, PAGE_SIZE);
